import { createBrowserRouter, RouterProvider } from 'react-router';
import { Layout } from '@/components/layout/Layout';
import Home from '@/pages/Home';
import About from '@/pages/About';
import ServicesOverview from '@/pages/ServicesOverview';
import ServiceDetail from '@/pages/ServiceDetail';
import Pricing from '@/pages/Pricing';
import Contact from '@/pages/Contact';
import LegalPage from '@/pages/LegalPage';
import NotFound from '@/pages/NotFound';

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/about', element: <About /> },
      { path: '/services', element: <ServicesOverview /> },
      { path: '/services/:slug', element: <ServiceDetail /> },
      { path: '/pricing', element: <Pricing /> },
      { path: '/contact', element: <Contact /> },
      { path: '/privacy-policy', element: <LegalPage type="privacy" /> },
      { path: '/terms-of-use', element: <LegalPage type="terms" /> },
      { path: '/refund-policy', element: <LegalPage type="refund" /> },
      { path: '/404', element: <NotFound /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
